import Header from './components/header/Header'
import Nav from './components/nav/Nav'
import About from './components/about/about'
import Experience from './components/experience/Experience'
import Services from './components/services/Services'
import Portfolio from './components/portfolio/Portfolio'
import Testimonials from './components/testimonials/Testimonials'
import Contacts from './components/contact/contact'
import Footer from './components/footer/Footer'
import './index.css'


const App = () => { 
    return (
        <> 
            <Header />
            <Nav /> 
            <About />
            <Experience />
            <Services />
            <Portfolio />
            <Testimonials />
            <Contacts />
            <Footer />
        </>
    )
}

export default App